export const stakeholderMockItems = [
  {
    id: "prospect-john-m",
    lane: "prospects",
    title: "John M.",
    bucket: "needs-now",
    reason: "Warm lead | asked 2 questions | no first call yet",
    next_move: "Call today",
    last_meaningful_movement: "Asked about Founding 40 and whether it fits his schedule.",
    follow_up_date: "2026-05-13",
    notes:
      "Strong fit. Pain sounds real. He wants support, not another men's program. Offer a short phone call, not a sales push.",
    is_kevin_flagged: true,
    source: "Personal network",
  },
  {
    id: "prospect-chris-r",
    lane: "prospects",
    title: "Chris R.",
    bucket: "needs-now",
    reason: "Strong fit | revisiting page | money hesitation",
    next_move: "Send value note and offer 10-minute call",
    last_meaningful_movement: "Returned to the page three times after initial outreach.",
    follow_up_date: "2026-05-14",
    notes:
      "He sounds hungry for help but is already talking himself out of investing in his own growth. Keep the tone supportive.",
    is_kevin_flagged: true,
    source: "Landing page follow-up",
  },
  {
    id: "prospect-dan-p",
    lane: "prospects",
    title: "Dan P.",
    bucket: "moving",
    reason: "Joined Founding 40 | asked thoughtful question",
    next_move: "Send warm confirmation",
    last_meaningful_movement: "Signed up and asked whether the brotherhood stays practical.",
    notes: "Good-fit ICA. Reinforce that he is not alone and that practical help is central.",
    is_kevin_flagged: false,
    source: "Church referral",
  },
  {
    id: "prospect-mike-t",
    lane: "prospects",
    title: "Mike T.",
    bucket: "watch",
    reason: "Resonates with message | minimizing pain",
    next_move: "Call this week if possible",
    last_meaningful_movement: "Said he probably just needs to try harder with the kids.",
    notes: "He sounds like a real fit, but is still softening the seriousness of his pain.",
    is_kevin_flagged: false,
    source: "Friend referral",
  },
  {
    id: "dad-james-l",
    lane: "dad-partners",
    title: "James L.",
    bucket: "needs-now",
    reason: "Went quiet after honest share about discouragement",
    next_move: "Personal encouragement by Wednesday",
    last_meaningful_movement: "Shared discouragement about home tension and then disappeared.",
    follow_up_date: "2026-05-14",
    notes:
      "This is exactly the kind of courage that should not be left hanging. Encourage him and keep the tone steady.",
    is_kevin_flagged: true,
  },
  {
    id: "dad-ask-brothers-thread",
    lane: "dad-partners",
    title: "Ask the Brothers thread",
    bucket: "needs-now",
    reason: "Advice tone is getting preachy",
    next_move: "Step in and reframe culture",
    last_meaningful_movement: "A question about marriage drew a long, advice-heavy response chain.",
    notes:
      "Use this as a teachable moment. Shift the tone back toward empathy, curiosity, and one or two practical steps.",
    is_kevin_flagged: true,
  },
  {
    id: "dad-bill-c",
    lane: "dad-partners",
    title: "Bill C.",
    bucket: "moving",
    reason: "Shared a real win with wife and kids",
    next_move: "Encourage publicly",
    last_meaningful_movement: "Said the house felt lighter this week and the kids wanted him to play.",
    notes: "This is the kind of small, repeatable win the culture should celebrate.",
    is_kevin_flagged: false,
  },
  {
    id: "dad-robert-s",
    lane: "dad-partners",
    title: "Robert S.",
    bucket: "moving",
    reason: "Asked for help honestly",
    next_move: "Watch for supportive responses",
    last_meaningful_movement: "Used Ask the Brothers for the first time in a real way.",
    notes: "A good sign of crossover from presence into engagement.",
    is_kevin_flagged: false,
  },
  {
    id: "dad-steve-m",
    lane: "dad-partners",
    title: "Steve M.",
    bucket: "watch",
    reason: "Active but surface-level only",
    next_move: "Look for gentle invitation point",
    last_meaningful_movement: "Still commenting, but never crossing into honesty.",
    notes: "He is present. He is not yet engaged.",
    is_kevin_flagged: false,
  },
  {
    id: "guide-karen-s",
    lane: "guide-partners",
    title: "Karen S.",
    bucket: "needs-now",
    reason: "Scheduled story share Thursday | no prep confirmation yet",
    next_move: "Call today",
    last_meaningful_movement: "Accepted the speaking slot but has not confirmed her story direction.",
    follow_up_date: "2026-05-13",
    notes:
      "She is a good fit. Do not overcomplicate this. Help her land on one honest story and one hopeful takeaway.",
    is_kevin_flagged: true,
  },
  {
    id: "guide-mike-r",
    lane: "guide-partners",
    title: "Mike R.",
    bucket: "needs-now",
    reason: "Selected Ask the Brothers | no visible activity in 3 weeks",
    next_move: "Send simple re-engagement note",
    last_meaningful_movement: "Chose a service area but has not actually stepped into it.",
    notes: "This is activation drift, not necessarily disinterest. Keep the invitation light.",
    is_kevin_flagged: false,
  },
  {
    id: "guide-susan-b",
    lane: "guide-partners",
    title: "Susan B.",
    bucket: "moving",
    reason: "Warm discussion responses | dads feel encouraged",
    next_move: "Thank her this week",
    last_meaningful_movement: "Left several comments that were validating, calm, and useful.",
    notes: "A model of relational ministry rather than distant advice.",
    is_kevin_flagged: false,
  },
  {
    id: "guide-tom-h",
    lane: "guide-partners",
    title: "Tom H.",
    bucket: "moving",
    reason: "Shared story well | followed up with hope and prayer",
    next_move: "Mark as dependable for future story slots",
    last_meaningful_movement: "Handled his story slot with steadiness and practical hope.",
    notes: "He is clearly serving with the right tone.",
    is_kevin_flagged: false,
  },
  {
    id: "guide-david-l",
    lane: "guide-partners",
    title: "David L.",
    bucket: "watch",
    reason: "Logs in and comments, but from a distance",
    next_move: "Send one coaching example",
    last_meaningful_movement: "Still offering opinions without directly ministering to a person.",
    notes: "Present, but not yet relationally helpful.",
    is_kevin_flagged: false,
  },
  {
    id: "advisory-brief",
    lane: "advisory-partners",
    title: "Next advisory rhythm",
    bucket: "needs-now",
    reason: "Founding 40 feedback brief is not prepared",
    next_move: "Outline advisory brief this week",
    last_meaningful_movement: "Advisory cadence was discussed, but the packet format is still undefined.",
    notes: "This is more a process issue than a people issue in v1.",
    is_kevin_flagged: false,
    advisory_signal_label: "Packet prep",
    detail_tags: ["Advisory rhythm", "Packet prep"],
  },
  {
    id: "advisory-mark-t",
    lane: "advisory-partners",
    title: "Mark T.",
    bucket: "moving",
    reason: "Initiated 2 strong ideas after early dad feedback",
    next_move: "Capture for future advisory packet",
    last_meaningful_movement: "Reached out with pattern-level observations and encouragement.",
    notes: "Good advisory tone: creative, engaged, not controlling.",
    is_kevin_flagged: false,
    advisory_signal_label: "Pattern-seeing",
    detail_tags: ["Pattern-seeing", "Encouragement"],
  },
  {
    id: "advisory-grounding",
    lane: "advisory-partners",
    title: "Grounding signal",
    bucket: "watch",
    reason: "Good ideas present, but not enough real dad contact",
    next_move: "Keep advisory lane tied to live Guide Partner work",
    last_meaningful_movement: "The concept is strong, but the structure does not exist yet.",
    notes: "This is the main risk for the lane becoming too abstract.",
    is_kevin_flagged: false,
    advisory_signal_label: "Grounding risk",
    detail_tags: ["Grounding risk", "Needs dad contact"],
  },
  {
    id: "support-paused-giver",
    lane: "support-partners",
    title: "Paused monthly giver",
    bucket: "needs-now",
    reason: "One supporter appears to have paused recurring giving",
    next_move: "Make gracious personal check-in call",
    last_meaningful_movement: "Last monthly gift did not recur on expected timing.",
    notes:
      "Lead with care, not pressure. The pause may be financial strain, disappointment, or just life noise.",
    is_kevin_flagged: true,
    support_status_label: "paused",
    contact_email: "supporter@example.com",
    detail_tags: ["Paused", "Direct contact"],
  },
  {
    id: "support-eight-active",
    lane: "support-partners",
    title: "8 active supporters",
    bucket: "moving",
    reason: "Steady giving continues",
    next_move: "Keep visible impact communication strong",
    last_meaningful_movement: "Monthly giving remains stable.",
    notes: "Support is present, but must stay connected to real stories.",
    is_kevin_flagged: false,
    support_status_label: "active",
    detail_tags: ["Active", "Monthly giving"],
  },
  {
    id: "support-story-engagement",
    lane: "support-partners",
    title: "Quiet story engagement",
    bucket: "watch",
    reason: "Several supporters are giving but not responding to stories",
    next_move: "Improve next impact update quality",
    last_meaningful_movement: "Recent giving stayed steady, but email/story response was low.",
    notes: "Watch for the lane becoming transactional.",
    is_kevin_flagged: false,
    support_status_label: "watch",
    detail_tags: ["Quiet engagement", "Story response low"],
  },
  {
    id: "superfan-wife-referral",
    lane: "super-fans",
    title: "Wife of J.P.",
    bucket: "needs-now",
    reason: "Reached out with excitement and asked how to help",
    next_move: "Acknowledge and send Super Fan guide",
    last_meaningful_movement: "Shared gratitude for the change she sees in her husband.",
    notes: "A likely high-trust amplifier. Respond quickly.",
    is_kevin_flagged: false,
    relationship_label: "Wife",
    amplification_label: "Referral",
    detail_tags: ["Wife", "Referral"],
  },
  {
    id: "superfan-active-five",
    lane: "super-fans",
    title: "5 active amplifiers",
    bucket: "moving",
    reason: "Posts, shares, and comments are visible this month",
    next_move: "Keep them fueled with fresh stories",
    last_meaningful_movement: "Recent posts were liked, shared, and forwarded.",
    notes: "This lane runs on visible good news.",
    is_kevin_flagged: false,
    amplification_label: "Sharing",
    detail_tags: ["Sharing", "Comments"],
  },
  {
    id: "superfan-cooling",
    lane: "super-fans",
    title: "Known superfans quieter this month",
    bucket: "watch",
    reason: "Enthusiasm may be cooling without fresh touchpoints",
    next_move: "Plan a fresh invitation or story touchpoint",
    last_meaningful_movement: "Amplification dropped after the last burst of content.",
    notes: "They may just need something hopeful to share.",
    is_kevin_flagged: false,
    amplification_label: "Cooling",
    detail_tags: ["Cooling", "Needs touchpoint"],
  },
  {
    id: "operations-cash-truth",
    lane: "operations",
    title: "Financial condition",
    bucket: "needs-now",
    reason: "Cash trend needs current verification",
    next_move: "Review current numbers this week",
    last_meaningful_movement: "Support and cost picture have not been pulled into one clean view yet.",
    notes: "The biggest operations risk is unclear truth, not just bad truth.",
    is_kevin_flagged: true,
    type: "financial",
  },
  {
    id: "operations-support-update",
    lane: "operations",
    title: "Supporter impact update",
    bucket: "needs-now",
    reason: "Monthly impact communication is due",
    next_move: "Draft and send by Friday",
    last_meaningful_movement: "The last update went out, but the next one is not prepared.",
    notes: "If this slips, supporter trust softens.",
    is_kevin_flagged: false,
    type: "delivery",
  },
  {
    id: "operations-reporting",
    lane: "operations",
    title: "Weekly review rhythm",
    bucket: "moving",
    reason: "This week’s review structure is now defined",
    next_move: "Turn it into a real report screen later",
    last_meaningful_movement: "The operating report structure was clarified.",
    notes: "A good sign toward peace of mind.",
    is_kevin_flagged: false,
    type: "reporting",
  },
  {
    id: "operations-marketing",
    lane: "operations",
    title: "Marketing clarity",
    bucket: "watch",
    reason: "Spend and outreach effort are active, but result visibility is still thin",
    next_move: "Define what numbers must be answerable",
    last_meaningful_movement: "Questions about marketing return remain too manual.",
    notes: "Do not overbuild analytics before clarifying the few answers Kevin actually needs.",
    is_kevin_flagged: false,
    type: "marketing",
  },
];
